import { Backdrop } from "@mui/material";
import { useState } from "react";
import styled from "styled-components";
import theme from "../../theme/theme";

const Card = styled.section`
  background-color: #fff;
  box-sizing: border-box;
  width: 40%;
  border-radius: 10px;
  padding: 30px;

  @media (max-width: 480px) {
    width: 90%;
  }

  h2 {
    color: ${theme.colors.primaryStrong2X};
    @media (max-width: 480px) {
      font-size: 24px;
    }
  }
`;

const ErrorPopUp = () => {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
      onClick={handleClose}
    >
      <Card>
        <h2>
          Oops! An error has occurred. Please go to the dashboard to continue
          with your goal
        </h2>
      </Card>
    </Backdrop>
  );
};

export default ErrorPopUp;
